<template>
  <div class="mod-overlay">
    <div class="mod-modal turno-modal">
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar turno' : 'Nuevo turno' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <form class="mod-modal-body" @submit.prevent="handleSubmit">
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <div class="mod-field">
            <label for="Clave">Clave <span class="mod-required">*</span></label>
            <input id="Clave" v-model="form.Clave" type="text" :disabled="isEdit" required maxlength="50" placeholder="MAT">
          </div>
          <div class="mod-field">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input id="Nombre" v-model="form.Nombre" type="text" required maxlength="120" placeholder="Matutino">
          </div>
          <div class="mod-field">
            <label for="Alias">Alias</label>
            <input id="Alias" v-model="form.Alias" type="text" maxlength="50" placeholder="Mañana">
          </div>
          <div class="mod-field">
            <label for="ClaveErp">Clave ERP</label>
            <input id="ClaveErp" v-model="form.ClaveErp" type="text" maxlength="50" placeholder="Clave externa">
          </div>
          <div class="mod-field">
            <label for="FechaDesde">Fecha desde</label>
            <input id="FechaDesde" v-model="form.FechaDesde" type="date">
          </div>
          <div class="mod-field">
            <label for="FechaHasta">Fecha hasta</label>
            <input id="FechaHasta" v-model="form.FechaHasta" type="date">
          </div>
          <div class="mod-field">
            <label for="HoraDesde">Horario desde</label>
            <input id="HoraDesde" v-model="form.HoraDesde" type="time" required>
          </div>
          <div class="mod-field">
            <label for="HoraHasta">Horario hasta</label>
            <input id="HoraHasta" v-model="form.HoraHasta" type="time" required>
          </div>
          <div class="mod-field">
            <label for="MinutosDescanso">Minutos descanso</label>
            <input id="MinutosDescanso" v-model.number="form.MinutosDescanso" type="number" min="0" placeholder="60">
          </div>
          <div class="mod-field">
            <label for="MinutosToleranciaEntrada">Tolerancia entrada</label>
            <input id="MinutosToleranciaEntrada" v-model.number="form.MinutosToleranciaEntrada" type="number" min="0" placeholder="10">
          </div>
          <div class="mod-field">
            <label for="MinutosToleranciaSalida">Tolerancia salida</label>
            <input id="MinutosToleranciaSalida" v-model.number="form.MinutosToleranciaSalida" type="number" min="0" placeholder="10">
          </div>
          <div class="mod-field">
            <label for="Color">Color</label>
            <input id="Color" v-model="form.Color" type="color">
          </div>
          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input v-model="form.CruzaDia" type="checkbox">
              <span>Cruza día</span>
            </label>
          </div>
          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input v-model="form.EsPredeterminado" type="checkbox">
              <span>Predeterminado</span>
            </label>
          </div>
          <div class="mod-field">
            <label for="Orden">Orden</label>
            <input id="Orden" v-model.number="form.Orden" type="number" min="0">
          </div>
          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input v-model="form.EsActivo" type="checkbox">
              <span>Activo</span>
            </label>
          </div>

          <div class="mod-field turno-wide">
            <label>Días laborables</label>
            <div class="turno-days">
              <label v-for="dia in dias" :key="dia.value" class="turno-day" :class="{ selected: selectedDays.includes(dia.value) }">
                <input v-model="selectedDays" type="checkbox" :value="dia.value">
                <span>{{ dia.label }}</span>
              </label>
            </div>
          </div>

          <div class="mod-field turno-wide">
            <label for="Descripcion">Descripción</label>
            <input id="Descripcion" v-model="form.Descripcion" type="text" maxlength="255" placeholder="Uso interno, reglas o notas del turno">
          </div>
        </div>

        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">Cancelar</button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear turno' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import authService from '@/services/auth';
import { showToast } from '@/shared/utils/toast';
import { createTurno } from './turno.model';
import turnoService from './turno.service';

export default {
  name: 'TurnoForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createTurno(),
      selectedDays: [1, 2, 3, 4, 5],
      saving: false,
      error: null,
      dias: [
        { value: 0, label: 'Dom' },
        { value: 1, label: 'Lun' },
        { value: 2, label: 'Mar' },
        { value: 3, label: 'Mié' },
        { value: 4, label: 'Jue' },
        { value: 5, label: 'Vie' },
        { value: 6, label: 'Sáb' }
      ]
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = {
        ...createTurno(),
        ...this.item,
        FechaDesde: this.toDateInput(this.item.FechaDesde),
        FechaHasta: this.toDateInput(this.item.FechaHasta),
        HoraDesde: this.toTimeInput(this.item.HoraDesde),
        HoraHasta: this.toTimeInput(this.item.HoraHasta)
      };
      this.selectedDays = this.parseDays(this.item.DiasLaborables);
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    parseDays(value) {
      const days = String(value || '')
        .split(',')
        .map(x => Number(x.trim()))
        .filter(x => x >= 0 && x <= 6);
      return days.length ? [...new Set(days)].sort((a, b) => a - b) : [1, 2, 3, 4, 5];
    },
    toDateInput(value) {
      return value ? String(value).slice(0, 10) : '';
    },
    toTimeInput(value) {
      return value ? String(value).slice(0, 5) : '';
    },
    toTimePayload(value) {
      if (!value) return null;
      return String(value).length === 5 ? `${value}:00` : value;
    },
    async handleSubmit() {
      this.saving = true;
      this.error = null;
      if (!this.form.Clave || !this.form.Nombre) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }
      if (this.selectedDays.length === 0) {
        this.error = 'Selecciona al menos un día laborable';
        this.saving = false;
        return;
      }
      try {
        const result = await turnoService.guardar({
          ...this.form,
          Clave: String(this.form.Clave || '').trim().toUpperCase(),
          DiasLaborables: [...this.selectedDays].sort((a, b) => a - b).join(','),
          HoraDesde: this.toTimePayload(this.form.HoraDesde),
          HoraHasta: this.toTimePayload(this.form.HoraHasta),
          FechaDesde: this.form.FechaDesde || null,
          FechaHasta: this.form.FechaHasta || null
        });
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch {
        this.error = 'Error de conexión con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";

.turno-modal {
  max-width: 980px;
}

.turno-wide {
  grid-column: span 2;
}

.turno-days {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 0.45rem;
}

.turno-day {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 38px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  color: #334155;
  font-weight: 700;
  cursor: pointer;
}

.turno-day input {
  width: 14px;
  height: 14px;
}

.turno-day.selected {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
}

@media (max-width: 720px) {
  .turno-wide {
    grid-column: span 1;
  }

  .turno-days {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
